'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _appStepRoutes = require('../../../core/constants/appStepRoutes');

var _appStepRoutes2 = _interopRequireDefault(_appStepRoutes);

var _RouterActions = require('../../../core/actions/RouterActions');

var _Auth = require('../../../core/utils/Auth');

var _Auth2 = _interopRequireDefault(_Auth);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _Lazy = require('../../../core/routeHandlers/Lazy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var existingUserStep = function existingUserStep() {
  var authedNewUserClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _appStepRoutes2.default.JOIN_HUBSPOT_ACCOUNT;
  var wordpress = arguments[1];

  return {
    route: _appStepRoutes2.default.EXISTING_USER,
    handler: function handler(props) {
      return _react2.default.createElement(
        _react2.default.Suspense,
        { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
        _react2.default.createElement(_Lazy.AuthedStartDisplay, props)
      );
    },
    props: {
      AuthHandler: _Auth2.default,
      handleAuthedNewUserClick: _RouterActions.goToStep.bind(null, authedNewUserClick),
      handleAuthedExistingUserClick: _RouterActions.goToStep.bind(null, _appStepRoutes2.default.EXISTING_ACCOUNTS),
      wordpress: wordpress
    }
  };
};

exports.default = existingUserStep;
module.exports = exports['default'];